import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from '../styles';

interface IProps {
	description?: string;
	title: string;
}

export const EmptyState: React.FC<IProps> = ({ description, title }) => (
	<div className={css(styleSheet.emptyState)}>
		<h2 className={css(styleSheet.emptyStateTitle)}>{title}</h2>
		{description ? <p className={css(styleSheet.emptyStateDescription)}>{description}</p> : null}
	</div>
);
